export default "__VITE_ASSET__BNlYYEWQ__"